import { PlusIcon, QuestionIcon } from '@/_assets/icon-components';
import NumberToPrice from '@/_components/NumberToPrice';
import { useCustomLocale } from '@/_hooks/useCustomLocale';
import { useTelegram } from '@/_providers/telegram';
import { ADD_TO_CART } from '@/_store/cart/cart.slice';
import { IAutoAddingProduct } from '@/_types';
import { IProduct } from '@/entities/product/model/types';
import { AspectRatio, Box, Flex, Text } from '@chakra-ui/react';
import { track } from '@/_utils/utm';
import { useTranslations } from 'next-intl';
import { useDispatch } from 'react-redux';
import Image from 'next/image';
import { BRAND_NAMES } from '@/_utils/Constants';

interface IProps {
  product?: IProduct;
  autoAddingProduct?: IAutoAddingProduct;
  shipperId: string;
  menuId: string;
  branchId: string;
  sourceId: string;
}

export default function NeedRecProduct({
  product,
  autoAddingProduct,
  shipperId,
  menuId,
  branchId,
  sourceId,
}: IProps) {
  const t = useTranslations();
  const dispatch = useDispatch();
  const { tg_chat_id } = useTelegram();
  const currentLocale = useCustomLocale();

  const addToCartHandler = () => {
    if (autoAddingProduct) {
      dispatch(
        ADD_TO_CART({
          image: autoAddingProduct?.product?.image || '',
          brand: BRAND_NAMES[shipperId],
          key: '',
          comment: '',
          in_stop: false,
          default_product: false,
          discount_percent: 0,
          category_id: "",
          product_name:
            autoAddingProduct?.product?.title?.[currentLocale] || '',
          category_name: '',
          is_optional: !!autoAddingProduct?.is_optional,
          price: autoAddingProduct?.product?.out_price || 0,
          price_with_discount: autoAddingProduct?.product?.out_price || 0,
          product_id: autoAddingProduct?.product_id,
          type: autoAddingProduct?.product?.type,
          variants: {},
          order_modifiers: [],
          quantity: autoAddingProduct?.min_qty,
          min_qty: autoAddingProduct?.min_qty,
          max_qty: autoAddingProduct?.max_qty,

          shipper_id: shipperId,
          branch_id: branchId,
          menu_id: menuId,
          source_id: sourceId,
        }),
      );
      track({
        action_type: 'add_to_cart',
        tg_chat_id,
      });
    }
  };

  return (
    <Box mb={3}>
      <Flex alignItems='center' justifyContent='space-between'>
        <Flex gap={4} alignItems='center' flexGrow={1}>
          <AspectRatio
            minW={{ base: '36px', lg: '36px' }}
            bg={'background'}
            ratio={1 / 1}
            overflow='hidden'
            rounded={16}
          >
            {product?.image ? (
              <Image
                src={process.env.BASE_URL + product?.image}
                alt={`${product?.title?.[currentLocale]} - photo`}
                style={{ objectFit: 'cover' }}
                fill
              />
            ) : (
              <Box>
                <QuestionIcon />
              </Box>
            )}
          </AspectRatio>
          <Box flexGrow={1}>
            <Text fontWeight={600}>
              {product?.title?.[currentLocale] || product?.title?.ru}
            </Text>
            {!!product?.weight && (
              <Text color='text.muted' fontWeight={500}>
                {product?.weight} {t('grams')}.
              </Text>
            )}
          </Box>
        </Flex>
        <Box>
          <Flex
            bg='background'
            color='text'
            alignItems='center'
            gap={1}
            rounded={12}
            minW='116px'
            p={2}
            h='36px'
            cursor='pointer'
            onClick={addToCartHandler}
          >
            <NumberToPrice
              value={product?.out_price || 0}
              textProps={{
                fontWeight: { base: 400, lg: 500 },
                color: 'text',
              }}
              spanProps={{
                fontWeight: { base: 400, lg: 500 },
                color: 'text',
                fontSize: { base: 'sm', lg: 'md' },
              }}
            />
            <Box mb={0.5} color='text'>
              <PlusIcon size={20} color='currentColor' />
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}
